import { render } from "./cardsIcon.vue?vue&type=template&id=048a0989"
const script = {}

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__